import {
  ApiCallState,
  NotificationGroups,
  NotificationStatus,
} from '../constants/notifications.js';

export type Notification = {
  id: string;
  resourceType: NotificationGroups;
  subGroup: string;
  subject: string;
  resourceId: string;
  locations: string[];
  createdAt: string;
  accountNumber: string;
  createdBy: string;
  status: NotificationStatus;
};

export type ApiCallResult = {
  State: ApiCallState;
  Message: string;
};
